import React from "react";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { ContentItems } from "./ContentItems";
import { Group, Tag } from "../core/pdf/types";
import { GroupContext } from "./useGroup";
import { ElementTag } from "./ElementTag";

export function TagEditor(props: {
	tag: Tag,
}) {
	const designer = useDesigner();

	const tagState = React.useMemo(() => {
		return {
			item: props.tag, 
		}
	}, [props.tag]);

	const elementContext = useElementContext(props.tag);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const contentStyle = {};

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={"group-editor content-element flex align-start " + state.classes}
				data-key={props.tag.id}
				id={state.elementID}
				tabIndex={0}
			>
				<div style={contentStyle} className="fill">
					<ContentItems
						content={props.tag.content}
					/>
				</div>
			</div>
		</ElementContext.Provider>
	)
}